import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DropdownMenu, DropdownToggle, Nav, NavItem, Dropdown, DropdownItem,  } from 'reactstrap';
import PropTypes from 'prop-types';
import cookie from 'react-cookies'

import HeaderClock from '../Widgets/HeaderClock'
import AlertNotification from '../Widgets/AlertNotification'

import { fetchGetSatuanPage } from '../../redux/actions/satuan/aSatuan-GetPageSatuan';

const propTypes = {
  children: PropTypes.node,
  noSelectable: PropTypes.bool,
};

const defaultProps = {
  noSelectable: false,
};

class DefaultHeader extends Component {
  constructor(props){
    super(props)

    this.state = {
      currency: '',
      dropDownOpen: '',
      division_name: cookie.load('division_name_view_dashboard') ? cookie.load('division_name_view_dashboard') : cookie.load('divisionName'),
      division_id: cookie.load('division_id_view_dashboard') ? cookie.load('division_id_view_dashboard') : cookie.load('division_id')
   }
  }
 
 toggle = () => {
     this.setState({
        dropDownOpen: !this.state.dropDownOpen,
     })
 }
 
 componentDidMount(){
   this.props.fetchGetSatuanPage()
 }

 handleChangeDivision = (item) => {
   this.setState({
     division_name: item.division_name,
     division_id: item.division_id
   })
   cookie.save('division_id_view_dashboard', item.division_id, {path: '/'})
   cookie.save('division_name_view_dashboard', item.division_name, {path: '/'}),
   window.location.reload()
 } 

  render() {
    // eslint-disable-next-line
    const { dataPage, dataPageSatuan, children, noSelectable, ...attributes } = this.props;
    const { dropDownOpen, division_name, division_id } = this.state

    return (
      <React.Fragment>
      <div style={{width: '-webkit-fill-available'}}>
        <div style={{display: 'flex', flexDirection: 'row'}}>
        <Nav style={{marginLeft: '20px'}} navbar>
          <HeaderClock />
        </Nav>

        <Nav className="ml-auto" navbar style={{ fontSize: "14px", fontWeight: "bold" }}>
          <NavItem className="d-md-down-none">
         
          {noSelectable?
            <p style={{color: '#fff', fontWeight: '400', marginRight: '24px', marginBottom: '0', fontSize: '18px'}}>HARWAT ALUTSISTA</p>
            :
            <Dropdown isOpen={dropDownOpen} toggle={this.toggle}  style={{color:"#FFF", backgroundColor:"transparent", border:0}} >
                      <DropdownToggle style={{color:"#FFF",  fontSize: '18px', backgroundColor:"transparent", border:0}} caret >
                        {division_name}
                      </DropdownToggle>
                      <DropdownMenu style={{color: '#fff', background: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(10px)', border: '1px solid #9F9F9F', maxHeight: 200, overflowY: 'scroll', overflowX: 'hidden', right: 0}}>
                      {
                        division_id != cookie.load('division_id') ?
                        <DropdownItem style={{color: '#fff', background: 'rgba(203, 203, 203, 0.15)', backdropFilter: 'blur(10px)', border: 0}} onClick={() => this.setState({division_id: cookie.load('division_id'), division_name: cookie.load('divisionName')}, cookie.save('division_id_view_dashboard', cookie.load('division_id'), {path: '/'}), cookie.save('division_name_view_dashboard', cookie.load('divisionName'), {path: '/'}), window.location.reload())}> 
                          {cookie.load('divisionName')}
                        </DropdownItem> : null
                      }
                      {
                        dataPageSatuan.length > 0 ?
                        dataPageSatuan.map((item, index) => 
                        <DropdownItem style={{color: '#fff', background: 'rgba(203, 203, 203, 0.15)', backdropFilter: 'blur(10px)', border: 0}} onClick={() => this.handleChangeDivision(item)}> 
                          {item.division_name}
                        </DropdownItem>
                        ) : <DropdownItem style={{color: '#fff', background: 'rgba(203, 203, 203, 0.15)', backdropFilter: 'blur(10px)', border: 0}}> 
                        Belum ada Satuan
                      </DropdownItem>
                      }
                      </DropdownMenu>
                      </Dropdown>}

         
        </NavItem>
                        
         </Nav>
        </div>
        {children}
        <AlertNotification />
        </div>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  return {
     
    dataPage: state.getSatuanPageDataStore.dataPage,
    dataPageSatuan: state.getSatuanPageDataStore.dataPageSatuan,
      
    }
}

export default connect(mapStateToProps, {fetchGetSatuanPage}) (DefaultHeader);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js